import { connect } from 'react-redux';
import { AuthenticatedRoute } from '../../components';
import { authenticate } from '../../redux/actions/auth';
import { withRouter } from 'react-router-dom';

const mapStateToProps = (state, ownProps) => {
  const { user, authenticate, authenticating, authenticateFail, ...spread } = ownProps;
  return {
    user: state.auth.user,
    authenticating: state.auth.authenticating,
    authenticateFail: state.auth.authenticateFail,
    payload: state.auth.payload,
    ...spread
  };
};

const mapDispatchToProps = {
  authenticate
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthenticatedRoute));



// WEBPACK FOOTER //
// ./src/containers/AuthenticatedRoute/AuthenticatedRoute.js